var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "pa-3 mb-4",
      staticStyle: { "min-height": "150px" },
      attrs: { rounded: "", elevation: "1" },
    },
    [
      _c(
        "v-form",
        [
          _c("v-text-field", {
            attrs: { label: "Phone Number", fluid: "", "hide-details": "" },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _vm.app.callIsActive()
                      ? _c(
                          "v-menu",
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            { attrs: { icon: "" } },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v(" mdi-voicemail ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              978885944
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.app.transfer_call()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Auido 1"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.app.transfer_call()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Audio 2"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.app.callIsActive()
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      !_vm.app.call.isMuted()
                                        ? _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.app.call.mute(
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "green" } },
                                                [_vm._v(" mdi-microphone ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.app.call.mute(
                                                        false
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "red" } },
                                                [_vm._v(" mdi-microphone-off ")]
                                              ),
                                            ],
                                            1
                                          ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              428514
                            ),
                          },
                          [_c("span", [_vm._v("Unmute")])]
                        )
                      : _vm._e(),
                    !_vm.app.callIsActive()
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.app.make_call({
                                                    to: _vm.app
                                                      .phone_number_input,
                                                    contact_id:
                                                      _vm.app.current_lead.ID,
                                                  })
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "green" } },
                                            [_vm._v(" mdi-phone ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              676062003
                            ),
                          },
                          [_c("span", [_vm._v("Call")])]
                        )
                      : _vm._e(),
                    !_vm.app.callIsActive()
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.app.make_call({
                                                    to: _vm.app
                                                      .phone_number_input,
                                                    contact_id:
                                                      _vm.app.current_lead.ID,
                                                    voicemail: true,
                                                  })
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "green" } },
                                            [_vm._v(" mdi-phone-missed ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              806360260
                            ),
                          },
                          [_c("span", [_vm._v("Call to Voicemail")])]
                        )
                      : _vm._e(),
                    _vm.app.callIsActive()
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.app.hangUp()
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v(" mdi-phone-off ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4633776
                            ),
                          },
                          [_c("span", [_vm._v("Hang Up")])]
                        )
                      : _vm._e(),
                    _vm.app.callIsActive()
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: _vm.app.showCallInfo,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v(" mdi-account-plus ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4085715476
                            ),
                          },
                          [_c("span", [_vm._v("Add a Coach")])]
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: { click: _vm.app.showCallInfo },
                      },
                      [
                        _c("v-icon", { attrs: { color: "grey" } }, [
                          _vm._v(" mdi-cog "),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.app.phone_number_input,
              callback: function ($$v) {
                _vm.$set(_vm.app, "phone_number_input", $$v)
              },
              expression: "app.phone_number_input",
            },
          }),
          !_vm.app.callIsActive() && _vm.phone_numbers.length > 1
            ? _c(
                "div",
                _vm._l(_vm.phone_numbers, function (number) {
                  return _c(
                    "span",
                    { key: number },
                    [
                      number != _vm.app.phone_number_input
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-2 mr-2",
                              attrs: {
                                rounded: "",
                                small: "",
                                color: "secondary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.app.phone_number_input = number
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.app.phoneNumberFormat(number)))]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mt-2 mr-2",
                              attrs: { rounded: "", small: "", disabled: "" },
                            },
                            [_vm._v(_vm._s(_vm.app.phoneNumberFormat(number)))]
                          ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.app.callIsActive()
            ? _c("div", { staticStyle: { height: "55px" } }, [
                _c(
                  "div",
                  { staticClass: "mt-2 mb-2" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("1")
                          },
                        },
                      },
                      [_vm._v("1")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("2")
                          },
                        },
                      },
                      [_vm._v("2")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("3")
                          },
                        },
                      },
                      [_vm._v("3")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("4")
                          },
                        },
                      },
                      [_vm._v("4")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("5")
                          },
                        },
                      },
                      [_vm._v("5")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("6")
                          },
                        },
                      },
                      [_vm._v("6")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("7")
                          },
                        },
                      },
                      [_vm._v("7")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("8")
                          },
                        },
                      },
                      [_vm._v("8")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("9")
                          },
                        },
                      },
                      [_vm._v("9")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("0")
                          },
                        },
                      },
                      [_vm._v("0")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("*")
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { "x-small": "" } }, [
                          _vm._v("mdi-asterisk"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "mr-1 mb-1",
                        attrs: {
                          "x-small": "",
                          fab: "",
                          elevation: "1",
                          color: "secondary",
                          dark: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.app.sendDigits("#")
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { "x-small": "" } }, [
                          _vm._v("mdi-pound"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }